import React from 'react';
import { Checkbox } from '@amzn/atoz-web/Checkbox';
import { Col } from '@amzn/atoz-web/Col';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { Row } from '@amzn/atoz-web/Row';
import { Label } from '@amzn/atoz-web/Text';
export var CheckboxList = function (_a) {
    var checkboxState = _a.checkboxState, checkboxListItems = _a.checkboxListItems, onStateChange = _a.onStateChange, dataTestId = _a.dataTestId, title = _a.title, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var checkboxes = checkboxState &&
        checkboxListItems.map(function (_a) {
            var checkboxStateKey = _a.checkboxStateKey, labelText = _a.labelText, labelLink = _a.labelLink;
            var checked = checkboxState[checkboxStateKey];
            var checkboxTestId = "".concat(dataTestId, "-checkbox-").concat(checkboxStateKey).replace(/\s/g, '');
            var labelTestId = "".concat(dataTestId, "-label-").concat(checkboxStateKey).replace(/\s/g, '');
            var checkbox = (React.createElement(Row, { key: checkboxStateKey, alignItems: "center", gridGap: "S200" },
                React.createElement(Checkbox, { disabled: disabled, id: checkboxStateKey, checked: checked, dataTestId: checkboxTestId, onChange: function () { return onStateChange(checkboxStateKey); } }),
                React.createElement(Label, { htmlFor: checkboxStateKey, dataTestId: labelTestId },
                    labelText,
                    labelLink)));
            return checkbox;
        });
    return (React.createElement(View, { dataTestId: dataTestId },
        React.createElement("fieldset", null,
            React.createElement("legend", null,
                React.createElement(Text, { fontSize: "T200", fontWeight: "bold", margin: ['S200', 0] }, title)),
            React.createElement(Col, { gridGap: "S200" }, checkboxes))));
};
